import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { logEvent, ActionType, ComponentType } from '@cbhq/client-analytics';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { BYTES_SUBSCRIBE_LOG_EVENT, BYTES_PRODUCT_NAME } from '../../shared/utils/consts.js';
import { explore, bytesUrl, cryptoBasics, tipsAndTutorials, cryptoGlossary, marketUpdates, whatIsBitcoin, whatIsCrypto, whatIsBlockchain, howToSetUpACryptoWallet, howToSendCrypto, taxesUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const handleBytesClick = () => {
  logEvent(BYTES_SUBSCRIBE_LOG_EVENT, {
    action: ActionType.click,
    componentType: ComponentType.button,
    step: 'navigation',
    component_source: 'footer'
  });
};
function LearnColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry,
    isUserFromCBPaymentsCountries = _useContext.isUserFromCBPaymentsCountries;
  const isCBPaymentsCountriesUser = isUserFromCBPaymentsCountries();
  const isUKUser = isUserFromCountry('GB');
  if (isUKUser || isCBPaymentsCountriesUser) return null;
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.learn),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      href: explore,
      children: formatMessage(titleMessages.explore)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: bytesUrl,
      onPress: handleBytesClick,
      children: formatMessage(titleMessages.bytes, {
        productName: BYTES_PRODUCT_NAME
      })
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: cryptoBasics,
      children: formatMessage(titleMessages.cryptoBasics)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: tipsAndTutorials,
      children: formatMessage(titleMessages.tipsAndTutorials)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: cryptoGlossary,
      children: formatMessage(titleMessages.cryptoGlossary)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: marketUpdates,
      children: formatMessage(titleMessages.marketUpdates)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: whatIsBitcoin,
      children: formatMessage(titleMessages.whatIsBitcoin)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: whatIsCrypto,
      children: formatMessage(titleMessages.whatIsCrypto)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: whatIsBlockchain,
      children: formatMessage(titleMessages.whatIsBlockchain)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: howToSetUpACryptoWallet,
      children: formatMessage(titleMessages.howToSetUpACryptoWallet)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: howToSendCrypto,
      children: formatMessage(titleMessages.howToSendCrypto)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.taxes),
      href: taxesUrl,
      children: formatMessage(messages.taxes)
    })]
  });
}
const LearnColumn$1 = /*#__PURE__*/memo(LearnColumn);
export { LearnColumn$1 as default };
//# sourceMappingURL=LearnColumn.js.map
